import en from './en';
import pl from './pl';
import cs from './cs';

export default { pl, en, cs };
